// Module
var code = "<div class=\"form-group\"> <label for=\"{{propertyName}}\" ng-class=\"{'ng-required': isRequired}\" class=\"control-label\">{{label}}</label> <div class=\"amt-filter-date\"> <amt-datepicker ng-model=\"filterItem.value\" mode=\"{{mode}}\" default-value=\"defaultValue\" is-required=\"isRequired\"> </amt-datepicker> </div> </div>";
// Exports
module.exports = code;